import Loadable from "@loadable/component";

const HelpDetailsPage = Loadable(
  () => import(/* webpackChunkName: "help_details_page" */ "./helpDetails")
);

export default HelpDetailsPage;
